import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { HttpService } from '../http.service';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { Messages } from '../constants/messages';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AddUserComponent } from './add-user/add-user.component';
import { TimeService } from '../time.service';

export interface User {
  user_name: string;
  email_id: string;
  mobile: string;
  carriers: Array<string>;
  roles: Array<string>;
  functions: Array<string>;
}

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})

export class UserDetailsComponent implements OnInit {

  userColumns: string[] = ['serialnumber', 'name', 'units', 'email', 'roles', 'functions', 'lastsignin', 'actions'];
  showLoader =false;
  userArray: any = [];
  carrierId: Subscription;
  showButtons = false;
  selectedUsersArray: any = [];


  messages = new Messages();
  helpData = [
    { head: 'Help', data: 'Add users (Branch Managers, Warehouse Manager, Dispatch personnel etc) and allocate Roles and Responsibilities against each individual.' },
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private dialog: MatDialog, private snackbar: SnackbarService, private timeService: TimeService, private valid: ValidationService, private http: HttpService,
    private events: EventService, private storage: StorageService, private route: Router, private translation: TranslateService) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
    this.getUsers();
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getUsers();
      },
      (err: any) => {
        console.log('err ::', err);
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  getUsers() {
    this.userArray = [];
    this.http.get('carrier_user/all').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          const result = data.data;
          if (result && result.length) {
            result.forEach(element => {
              const temp: any = {
                roles: [],
                functions: []
              };
              temp._id = element._id;
              temp.name = element.name;
              temp.units = (element.carriers && element.carriers.length) ? element.carriers : [];
              temp.email = element.email_id;
              temp.mobile = element.mobile;
              temp.lastsignin = element.last_signin ? this.readableDateTime(element.last_signin) : 'N/A';
              temp.roles = (element.roles && element.roles.length) ? element.roles : [];
              temp.functions = (element.functions && element.functions.length) ? element.functions : [];
              temp.selected = false;
              temp.alive = element.alive;
              if (element.roles.length) {
                element.roles.forEach(role => {
                  if (role.name == "Account Owner") {
                    temp.owner = true;
                    return;
                  }
                });
              }
              this.userArray.push(temp);
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
    console.log("userArray", this.userArray)
  }

  selectUser(event: any, user: any) {
    if (event.checked && this.selectedUsersArray.indexOf(user._id) == -1) {
      this.selectedUsersArray.push(user._id);
    } else if (this.selectedUsersArray.indexOf(user._id) > -1) {
      this.selectedUsersArray.splice(this.selectedUsersArray.indexOf(user._id), 1);
    }
    (this.selectedUsersArray.length) ? this.showButtons = true : this.showButtons = false;
  }

  optInWhatsApp() {
    if (this.selectedUsersArray.length > 3) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.USER_DETAILS.VALIDATION.MAX_FIVE_USERS'), '', 'err', 4000);
      return;
    }

    const dialogData: any = {
      name: this.translation.instant('MESSAGE.USER_DETAILS.DIALOG.CONFIRM'),
      text: this.translation.instant('MESSAGE.USER_DETAILS.DIALOG.WHATSAPP'),
    };
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getUsers();
      }
    });
  }
  openAddUserModal() {
    const dialogRef = this.dialog.open(AddUserComponent, {
      data: {}
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.statusCode == 200) {
        this.getUsers();
      }
    });
  }
  readableDateTime(date) {
    return this.timeService.toShortDateTime(date);
  }
  editUser(element) {
    const dataToSend: any = {
      data: element,
      edit: true
    };
    const dialogRef = this.dialog.open(AddUserComponent, {
      data: dataToSend
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.statusCode === 200) {
        this.getUsers();
      }
    });
  }

  blockUser(element) {
    const payload = {
      user_id: element._id
    };
    this.showLoader = true;
    this.http.post('carrier_user/soft_delete', payload).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.getUsers();
          this.snackbar.openSnackBar('Blocked Successfully');
        }
      },
      (err: any) => {
         this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
}
